import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  Collapse,
  Divider,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  ToggleButton,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import {
  getComprobanteAutorizacion,
  getProvidenciaAutorizacion,
} from '../../../services/Afiliado/Autorizaciones';
import { getReimprimirOrden } from '../../../services/Seo/Orden';
import {
  CalendarMonthRounded,
  DeleteOutlineRounded,
  ForwardToInboxRounded,
  GetAppOutlined,
  KeyboardArrowDownRounded,
  KeyboardArrowUpRounded,
  MoreVertRounded,
  OpenInNewOutlined,
} from '@mui/icons-material';
import { AdjuntarDocumentacion } from './AdjuntarDocumentacion';

export const AutorizacionesItem = ({
  autorizacion,
  onEnviar,
  onEnviarProvidencia,
  onAnular,
  onPreview,
  onDescargar,
  onDescargarProvidencia,
  onDescargarOrden,
  isOpen = false,
  onToggleOpen,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openAction = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDescargar = async (filename, idAutorizacion) => {
    try {
      const urlReporte = await getComprobanteAutorizacion({
        id: idAutorizacion,
        enviarMail: false,
      });
      const link = document.createElement('a');
      link.style.display = 'none';
      link.setAttribute('href', urlReporte);
      link.setAttribute('download', 'Solicitud cobertura ' + filename + '.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      handleClose();
    } catch (e) {
      console.error(e);
    }
  };

  const handleDescargarProvidencia = async (filename, idAutorizacion) => {
    try {
      const urlReporte = await getProvidenciaAutorizacion({ id: idAutorizacion });
      const link = document.createElement('a');
      link.style.display = 'none';
      link.setAttribute('href', urlReporte);
      link.setAttribute('download', 'Providencia Solicitud cobertura ' + filename + '.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      handleClose();
    } catch (e) {
      console.error(e);
    }
  };

  const handleDescargarOrden = async (autorizacion) => {
    try {
      const urlReporte = await getReimprimirOrden({ numeroOrden: autorizacion.idOrdenAsociada });
      const link = document.createElement('a');
      link.style.display = 'none';
      link.setAttribute('href', urlReporte);
      link.setAttribute('download', 'Orden asociada autorización ' + autorizacion.numero + '.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (e) {
      console.error(e);
    }
  };

  const handleEnviar = (autorizacion) => {
    if (!onEnviar) return;
    onEnviar(autorizacion);
    handleClose();
  };

  const handleEnviarProvidencia = (autorizacion) => {
    if (!onEnviarProvidencia) return;
    onEnviarProvidencia(autorizacion);
    handleClose();
  };

  const handleAnular = (autorizacion) => {
    if (!onAnular) return;
    onAnular(autorizacion);
    handleClose();
  };

  const handlePreview = (autorizacion) => {
    if (!onPreview) return;
    onPreview(autorizacion);
    handleClose();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        background: '#fff',
        px: 1,
        py: 2,
        borderRadius: '8px',
        border: (theme) => `1px solid ${isOpen ? theme.palette.primary.main : 'transparent'}`,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <ToggleButton
          aria-label='expand row'
          value='check'
          onChange={() => {
            onToggleOpen?.();
          }}
          sx={{ border: 0, p: 0, textTransform: 'none', flex: 1 }}
        >
          <Grid
            container
            direction='row'
            justifyContent='flex-start'
            alignItems='flex-start'
            gap={2}
            flexWrap='nowrap'
          >
            {isOpen ? <KeyboardArrowUpRounded /> : <KeyboardArrowDownRounded />}

            <Box
              sx={{
                width: '100%',
                alignItems: 'flex-start',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: 1,
                  mt: '2px',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CalendarMonthRounded sx={{ fontSize: '1rem' }} />
                  <Typography
                    variant='body1'
                    fontSize={'0.875rem'}
                    color={'InactiveCaptionText'}
                    fontWeight={'bold'}
                    noWrap
                  >
                    {autorizacion?.fechaestado}
                  </Typography>
                </Box>
                <Alert
                  icon={false}
                  severity={
                    {
                      1: 'info', // Iniciada	1
                      2: 'error', // Anulada	2
                      3: 'error', // Rechazada	3
                      4: 'success', // Aprobada	4
                      5: 'warning', // Trámite Incompleto	5
                      6: 'success', // En Auditoría PA	6
                      7: 'warning', // En Auditoría PR	7
                      8: 'warning', // Devuelta por error de selección de tipo de trámite	8
                      9: 'warning', // Devuelta por error de digitalización de la documentación	9
                      10: 'warning', // Devuelta por error de selección de documentación	10
                      11: 'warning', // Devuelta por faltante de documentación	11
                      12: 'warning', // Devuelta para evitar superposición de cobertura	12
                    }[autorizacion?.codigoEstado] || 'info'
                  }
                  sx={{
                    padding: '2px 6px',
                    fontSize: '0.675rem',
                    fontWeight: '700',
                    border: '1px solid',
                    borderRadius: '8px',
                    '& .MuiAlert-message': {
                      padding: 0,
                    },
                  }}
                >
                  {autorizacion?.estado?.split(' ')[0]}
                </Alert>
              </Box>
              <Typography variant='body1' fontWeight={'bold'} noWrap>
                {autorizacion?.afiliado}
              </Typography>
              <Typography variant='body1' color={'InactiveCaptionText'} fontWeight={'600'} noWrap>
                Nº {autorizacion?.idSolicitudCoberturaFormateado}
              </Typography>
            </Box>
          </Grid>
        </ToggleButton>
        <Box>
          <IconButton
            id='basic-button'
            aria-controls={openAction ? 'basic-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={openAction ? 'true' : undefined}
            onClick={handleClick}
            sx={{ px: 1, py: 0 }}
          >
            <MoreVertRounded />
          </IconButton>
          <Menu
            id='basic-menu'
            anchorEl={anchorEl}
            open={openAction}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            elevation={0}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              '& .MuiPaper-root': {
                borderRadius: 3,
                marginTop: 1,
                minWidth: 280,
                padding: '4px 8px',
                boxShadow:
                  'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
                '& .MuiMenu-list': {
                  padding: '4px 0',
                },
                '& .MuiMenuItem-root': {
                  '& .MuiSvgIcon-root': {
                    fontSize: '1.475rem',
                  },
                },
                '& .MuiListItemText-root': {
                  '& .MuiTypography-root': {
                    fontSize: '1.075rem',
                  },
                },
              },
            }}
          >
            {/* Enviar solicitud */}
            <MenuItem
              key={'enviar'}
              onClick={() => {
                handleEnviar(autorizacion);
              }}
              disabled={autorizacion.codigoEstado !== '1' && autorizacion.codigoEstado !== '4'}
            >
              <ListItemIcon>
                <ForwardToInboxRounded fontSize='small' />
              </ListItemIcon>
              <ListItemText>Enviar Solicitud</ListItemText>
            </MenuItem>
            {/* Enviar providencia */}
            <MenuItem
              key={'enviar-providencia'}
              onClick={() => {
                handleEnviarProvidencia(autorizacion);
              }}
              disabled={autorizacion.codigoEstado !== '3' && autorizacion.codigoEstado !== '4'}
            >
              <ListItemIcon>
                <ForwardToInboxRounded fontSize='small' />
              </ListItemIcon>
              <ListItemText>Enviar Providencia</ListItemText>
            </MenuItem>
            {/* Anular solicitud */}
            <MenuItem
              key={'anular'}
              onClick={() => {
                handleAnular(autorizacion);
              }}
              disabled={autorizacion.codigoEstado !== '1'}
            >
              <ListItemIcon>
                <DeleteOutlineRounded fontSize='small' color='error' />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ color: 'error' }}>
                Anular Solicitud
              </ListItemText>
            </MenuItem>
          </Menu>
        </Box>
      </Box>

      <Collapse in={isOpen} timeout='auto' unmountOnExit>
        <Divider />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 1, my: 1 }}>
          {autorizacion?.tipoCobertura && (
            <Box>
              <Typography variant={'body'} fontWeight={'bold'}>
                Tipo
              </Typography>
              <Typography>{autorizacion?.tipoCobertura}</Typography>
            </Box>
          )}

          {autorizacion?.estado && (
            <Box>
              <Typography variant={'body'} fontWeight={'bold'}>
                Estado
              </Typography>
              <Typography>
                {autorizacion?.estado} ({autorizacion?.fechaestado})
              </Typography>
            </Box>
          )}

          {autorizacion?.observacion && (
            <Box>
              <Typography variant={'body'} fontWeight={'bold'}>
                Observación
              </Typography>
              <Typography>
                {autorizacion?.observacion?.charAt(0).toUpperCase() +
                  autorizacion?.observacion?.slice(1).toLowerCase()}
              </Typography>
            </Box>
          )}

          {autorizacion?.practicas?.length > 0 && (
            <Box>
              <Typography fontWeight={'bold'}>Prestaciones autorizadas</Typography>
              {autorizacion?.practicas?.map((i, k) => (
                <Typography key={k}>{`${i?.cantidad || ''} x ${i?.nombre || ''}`}</Typography>
              ))}
            </Box>
          )}

          {/* Descargar */}
          {/* <MenuItem
                key={'descargar'}
                onClick={() => {
                  handleDescargar(autorizacion.afiliado, autorizacion.idSolicitudCobertura);
                }}
              >
                <ListItemIcon>
                  <PictureAsPdfOutlined fontSize='small' />
                </ListItemIcon>
                <ListItemText>Reporte PDF</ListItemText>
              </MenuItem> */}

          {/* Adjuntar documentación cuando el codigo estado es 11 */}
          {autorizacion?.codigoEstado === '11' && (
            <AdjuntarDocumentacion autorizacion={autorizacion} />
          )}

          {autorizacion?.codigoEstado !== '11' && (
            <>
              {/* Descargar orden */}
              <Button
                variant='contained'
                onClick={() => {
                  handleDescargarOrden(autorizacion);
                }}
                disabled={!autorizacion.idOrdenAsociada}
                startIcon={<GetAppOutlined />}
                disableElevation
              >
                Descargar Orden
              </Button>

              {/* <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, flexWrap: 'nowrap' }}> */}
              {/* Descargar solicitud/providencia */}
              <ButtonGroup aria-label='Basic button group'>
                <Button
                  variant='outlined'
                  size='small'
                  onClick={() => {
                    handleDescargarProvidencia(
                      autorizacion.afiliado,
                      autorizacion.idSolicitudCobertura,
                    );
                  }}
                  disabled={autorizacion.codigoEstado !== '3' && autorizacion.codigoEstado !== '4'}
                  startIcon={<GetAppOutlined />}
                >
                  Descargar Providencia
                </Button>
                {/* Ver solicitud */}
                <Button
                  variant='outlined'
                  size='small'
                  onClick={() => handlePreview(autorizacion)}
                  startIcon={<OpenInNewOutlined />}
                >
                  Ver Solicitud
                </Button>
              </ButtonGroup>
              {/* </Box> */}
            </>
          )}
        </Box>
      </Collapse>
    </Box>
  );
};
